import { Component } from '@angular/core';
import { ControlWidget } from 'ngx-schema-form';

@Component({
selector: 'my-custom-html-editor',
template: `
<div class="ui-g-12 sf-field-container">
<div class="ui-g-12 ui-md-4">
<span class="label" [attr.for]="id" [ngClass]="{'required': -1 !== (formProperty.parent.schema.required || []).indexOf(formProperty.path.split('/').slice(-1)[0])}">
{{ schema.description }}
</span>
</div>
<div class="ui-g-12 ui-md-8">
<ckeditor
[formControl]="control">

</ckeditor>
</div>
</div>
`,
styleUrls: ['./custom-widgets-styles.css']
})
export class HtmlEditorWidget extends ControlWidget {
}



// WEBPACK FOOTER //
// ./src/app/views/administration/apps-config/json-schema-form/custom-widgets/html.widget.ts